import {createReducer} from "redux-act";
import {
	IEvent,
	requestEventsJSONSuccess,
	setViewedEventID, setViewedRoundID,
	switchEventStatusToLive,
} from "modules/actions";
import {EventStatus} from "modules/enums";

interface IReducer {
	list: IEvent[];
	selectedEventID: null | number;
	selectedRoundID: null | number;
}

const defaultState: IReducer = {
	list: [],
	selectedEventID: null,
	selectedRoundID: null,
};

const onSetViewedRoundID = (state: IReducer, roundId: number | null) => ({
	...state,
	selectedRoundID: roundId
})

export const events = createReducer<typeof defaultState>({}, defaultState)
	.on(requestEventsJSONSuccess, (state, events) => ({
		...state,
		list: events,
	}))
	.on(setViewedEventID, (state, selectedEventID) => ({
		...state,
		selectedEventID,
		selectedRoundID: null,
	}))
	.on(switchEventStatusToLive, (state, eventID) => ({
		...state,
		list: state.list.map((event) =>
			event.id === eventID
				? {
						...event,
						status: EventStatus.Active,
				  }
				: event
		),
	}))
	.on(setViewedRoundID, onSetViewedRoundID)
